export interface JudicialRequirement {
  id: string;
  tenantId: string;
  studentId: string | null;
  studentName: string | null;
  caseId: string | null;
  tribunal: string;
  rit: string;
  ruc: string;
  numeroCausa: string;
  tipoRequerimiento: string;
  fechaRecepcion: string;
  fechaLimite: string;
  estado: JudicialRequirementState;
  prioridad: "baja" | "media" | "alta" | "critica";
  responsableId: string | null;
  responsableName: string | null;
  responsableRol: string | null;
  documentoOrigenNombre: string;
  comprobanteEnvioNombre: string | null;
  fechaEnvio: string | null;
  createdBy: string;
  createdByName: string;
  createdAt: string;
  updatedAt: string;
  semaforo: "verde" | "amarillo" | "rojo";
  semaforoMotivo: string;
  observaciones: string;
}

export type JudicialRequirementState =
  | "recibido"
  | "en_analisis_ia"
  | "datos_extraidos"
  | "pendiente_asignacion"
  | "solicitando_insumos"
  | "insumos_incompletos"
  | "insumos_completos"
  | "informe_en_elaboracion"
  | "borrador_generado"
  | "en_revision"
  | "aprobado"
  | "enviado_tribunal"
  | "vencido"
  | "cerrado";

export interface JudicialExtraction {
  id: string;
  tenantId: string;
  judicialRequirementId: string;
  extractedJson: {
    tribunal: string;
    fechaRecepcion: string;
    fechaLimite: string;
    rit: string;
    ruc: string;
    numeroCausa: string;
    estudiante: string;
    curso: string;
    tipoRequerimiento: string;
    informesSolicitados: string[];
    antecedentesRequeridos: string[];
    responsablesSugeridos: string[];
    nivelUrgencia: string;
    accionesRecomendadas: string[];
    advertencias: string[];
  };
  validatedBy: string | null;
  validatedByName: string | null;
  validatedAt: string | null;
  createdAt: string;
}

export interface JudicialTask {
  id: string;
  tenantId: string;
  judicialRequirementId: string;
  responsableId: string;
  responsableName: string;
  titulo: string;
  descripcion: string;
  estado: "pendiente" | "en_progreso" | "completada" | "vencida";
  fechaLimite: string;
  createdAt: string;
}

export interface JudicialLog {
  id: string;
  tenantId: string;
  judicialRequirementId: string;
  userId: string;
  userName: string;
  accion: string;
  detalle: string;
  createdAt: string;
}

export interface JudicialRequirementInput {
  id: string;
  tenantId: string;
  judicialRequirementId: string;
  tipoInsumo: string;
  descripcion: string;
  responsableId: string;
  responsableName: string;
  responsableRol: string;
  fechaLimite: string;
  estado: "pendiente" | "en_desarrollo" | "entregado" | "devuelto" | "aprobado" | "vencido";
  respuesta: string | null;
  createdAt: string;
}

const getStoredJudicial = (key: string, initial: any) => {
  if (typeof window !== "undefined" && window.localStorage) {
    const stored = localStorage.getItem(key);
    if (stored) {
      try { return JSON.parse(stored); } catch (e) { console.error(e); }
    } else {
      localStorage.setItem(key, JSON.stringify(initial));
    }
  }
  return initial;
};

export const saveMockJudicial = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    localStorage.setItem("ezer_mock_judicial_requirements", JSON.stringify(mockJudicialRequirements));
  }
};

// ── JUDICIAL REQUIREMENTS ──
export const mockJudicialRequirements: JudicialRequirement[] = getStoredJudicial("ezer_mock_judicial_requirements", [
  {
    id: "jr1", tenantId: "t1", studentId: "s3", studentName: "Vicente Díaz Leiva", caseId: "c3",
    tribunal: "Tribunal de Familia de Santiago",
    rit: "C-2345-2026", ruc: "2410123456-7", numeroCausa: "C-2345-2026",
    tipoRequerimiento: "Informe integral del estudiante",
    fechaRecepcion: "2026-05-28", fechaLimite: "2026-06-15",
    estado: "solicitando_insumos", prioridad: "critica",
    responsableId: "u4", responsableName: "Valentina Soto", responsableRol: "orientador",
    documentoOrigenNombre: "Oficio_Tribunal_Familia_C2345-2026.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-05-28T10:00:00", updatedAt: "2026-05-30T11:00:00",
    semaforo: "rojo", semaforoMotivo: "Insumo docente vencido desde 05/06. Informe sin generar. Plazo límite: 15/06.",
    observaciones: "Se requiere informe integral de rendimiento, comportamiento, asistencia y compromiso del apoderado. Profesor jefe Felipe Contreras no ha entregado insumos."
  },
  {
    id: "jr2", tenantId: "t1", studentId: "s6", studentName: "Amanda Hernández Tapia", caseId: "c6",
    tribunal: "Tribunal de Familia de San Miguel",
    rit: "P-1890-2026", ruc: "2410234567-8", numeroCausa: "P-1890-2026",
    tipoRequerimiento: "Informe de comportamiento y convivencia escolar",
    fechaRecepcion: "2026-05-20", fechaLimite: "2026-06-10",
    estado: "enviado_tribunal", prioridad: "critica",
    responsableId: "u4", responsableName: "Valentina Soto", responsableRol: "orientador",
    documentoOrigenNombre: "Oficio_Tribunal_Familia_P1890-2026.pdf",
    comprobanteEnvioNombre: "Comprobante_Envio_Tribunal_SanMiguel.pdf", fechaEnvio: "2026-06-09",
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-05-20T14:00:00", updatedAt: "2026-06-09T15:30:00",
    semaforo: "verde", semaforoMotivo: "Informe enviado el 09/06. Comprobante adjuntado. En espera de respuesta del tribunal.",
    observaciones: "Informe de comportamiento y convivencia escolar enviado exitosamente. Se adjuntó comprobante de envío por correo institucional."
  },
  {
    id: "jr3", tenantId: "t1", studentId: "s1", studentName: "Benjamín Aravena Muñoz", caseId: null,
    tribunal: "Tribunal de Garantía de Santiago",
    rit: "O-5678-2026", ruc: "2410345678-9", numeroCausa: "O-5678-2026",
    tipoRequerimiento: "Informe de rendimiento y comportamiento",
    fechaRecepcion: "2026-06-05", fechaLimite: "2026-06-20",
    estado: "pendiente_asignacion", prioridad: "alta",
    responsableId: null, responsableName: null, responsableRol: null,
    documentoOrigenNombre: "Oficio_Juzgado_Garantia_O5678-2026.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-06-05T09:00:00", updatedAt: "2026-06-05T09:00:00",
    semaforo: "rojo", semaforoMotivo: "No hay responsable asignado. No se han solicitado insumos. Plazo: 20/06.",
    observaciones: "Recibido oficio de Tribunal de Garantía solicitando informe de rendimiento y comportamiento del estudiante en el marco de procedimiento por ley de responsabilidad penal adolescente."
  },
  {
    id: "jr4", tenantId: "t1", studentId: "s5", studentName: "Lucas Guzmán Soto", caseId: "c5",
    tribunal: "Tribunal de Familia de Puente Alto",
    rit: "C-8912-2026", ruc: "2410456789-0", numeroCausa: "C-8912-2026",
    tipoRequerimiento: "Informe integral para medida de protección",
    fechaRecepcion: "2026-05-15", fechaLimite: "2026-06-01",
    estado: "vencido", prioridad: "critica",
    responsableId: "u4", responsableName: "Valentina Soto", responsableRol: "orientador",
    documentoOrigenNombre: "Oficio_Tribunal_Familia_PuenteAlto_C8912.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-05-15T11:00:00", updatedAt: "2026-06-01T00:00:00",
    semaforo: "rojo", semaforoMotivo: "PLAZO VENCIDO (01/06). Informe no generado. Se requiere respuesta urgente al tribunal.",
    observaciones: "⚠️ CRÍTICO: Requerimiento vencido. El tribunal ha solicitado información en el marco de una medida de protección. Se debe priorizar respuesta inmediata."
  },
  {
    id: "jr5", tenantId: "t1", studentId: "s2", studentName: "Martina Cáceres Rojas", caseId: "c2",
    tribunal: "Tribunal de Familia de San Bernardo",
    rit: "P-3456-2026", ruc: "2410567890-1", numeroCausa: "P-3456-2026",
    tipoRequerimiento: "Informe de convivencia escolar y relación con pares",
    fechaRecepcion: "2026-06-02", fechaLimite: "2026-06-25",
    estado: "datos_extraidos", prioridad: "alta",
    responsableId: null, responsableName: null, responsableRol: null,
    documentoOrigenNombre: "Resolucion_Tribunal_Familia_SanBernardo_P3456.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-06-02T16:00:00", updatedAt: "2026-06-02T16:30:00",
    semaforo: "amarillo", semaforoMotivo: "Datos extraídos por IA. Pendiente asignar responsable y solicitar insumos. Plazo: 25/06.",
    observaciones: "Tribunal solicita informe de convivencia escolar en el marco de denuncia por acoso escolar. Relacionado con caso CASE-2026-0043."
  },
  {
    id: "jr6", tenantId: "t1", studentId: "s7", studentName: "Cristóbal Ibáñez Vega", caseId: "c7",
    tribunal: "Tribunal de Familia de La Florida",
    rit: "C-6789-2026", ruc: "2410678901-2", numeroCausa: "C-6789-2026",
    tipoRequerimiento: "Informe de inasistencia y medidas de apoyo",
    fechaRecepcion: "2026-06-08", fechaLimite: "2026-06-22",
    estado: "recibido", prioridad: "alta",
    responsableId: null, responsableName: null, responsableRol: null,
    documentoOrigenNombre: "Oficio_Tribunal_Familia_LaFlorida_C6789.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-06-08T08:30:00", updatedAt: "2026-06-08T08:30:00",
    semaforo: "amarillo", semaforoMotivo: "Requerimiento recién recibido. Pendiente análisis IA y asignación de responsable.",
    observaciones: "Requerimiento recibido hoy. Relacionado con caso de inasistencia crónica del estudiante."
  },
  {
    id: "jr7", tenantId: "t1", studentId: "s4", studentName: "Isidora Flores Paredes", caseId: null,
    tribunal: "Tribunal de Familia de Santiago",
    rit: "P-4321-2026", ruc: "2410789012-3", numeroCausa: "P-4321-2026",
    tipoRequerimiento: "Informe de intervenciones realizadas y seguimiento",
    fechaRecepcion: "2026-05-10", fechaLimite: "2026-06-10",
    estado: "borrador_generado", prioridad: "alta",
    responsableId: "u4", responsableName: "Valentina Soto", responsableRol: "orientador",
    documentoOrigenNombre: "Oficio_Tribunal_Familia_Stgo_P4321.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-05-10T13:00:00", updatedAt: "2026-06-08T17:00:00",
    semaforo: "amarillo", semaforoMotivo: "Borrador generado por IA. Falta revisión humana y aprobación. Plazo: HOY 10/06.",
    observaciones: "Borrador generado con IA a partir de insumos recopilados. Urgente: revisar y enviar hoy antes del vencimiento."
  },
  {
    id: "jr8", tenantId: "t1", studentId: "s8", studentName: "Javiera Lagos Martínez", caseId: null,
    tribunal: "Juzgado de Letras y Garantía de Melipilla",
    rit: "O-2109-2026", ruc: "2410890123-4", numeroCausa: "O-2109-2026",
    tipoRequerimiento: "Informe de asistencia y rendimiento académico",
    fechaRecepcion: "2026-06-03", fechaLimite: "2026-06-17",
    estado: "en_analisis_ia", prioridad: "media",
    responsableId: null, responsableName: null, responsableRol: null,
    documentoOrigenNombre: "Oficio_Juzgado_Melipilla_O2109-2026.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u5", createdByName: "Roberto Muñoz",
    createdAt: "2026-06-03T10:00:00", updatedAt: "2026-06-03T10:00:00",
    semaforo: "amarillo", semaforoMotivo: "Documento en análisis por IA. Pendiente extracción de datos.",
    observaciones: "Cargado por Director. Se requiere extracción automática de datos con IA."
  },
  {
    id: "jr9", tenantId: "t1", studentId: null, studentName: null, caseId: null,
    tribunal: "Corte de Apelaciones de San Miguel",
    rit: "APEL-456-2026", ruc: "2410901234-5", numeroCausa: "APEL-456-2026",
    tipoRequerimiento: "Oficio solicitando informe institucional de protocolos aplicados",
    fechaRecepcion: "2026-05-25", fechaLimite: "2026-06-12",
    estado: "insumos_completos", prioridad: "alta",
    responsableId: "u5", responsableName: "Roberto Muñoz", responsableRol: "director",
    documentoOrigenNombre: "Oficio_Corte_Apelaciones_SanMiguel_APEL456.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u5", createdByName: "Roberto Muñoz",
    createdAt: "2026-05-25T15:00:00", updatedAt: "2026-06-07T12:00:00",
    semaforo: "amarillo", semaforoMotivo: "Insumos recopilados. Falta generar informe con IA y validar. Plazo: 12/06.",
    observaciones: "Corte de Apelaciones solicita informe institucional sobre protocolos de convivencia aplicados en el establecimiento."
  },
  {
    id: "jr10", tenantId: "t1", studentId: "s3", studentName: "Vicente Díaz Leiva", caseId: null,
    tribunal: "Tribunal de Familia de Santiago",
    rit: "C-5555-2026", ruc: "2410111222-3", numeroCausa: "C-5555-2026",
    tipoRequerimiento: "Informe complementario de compromiso del apoderado",
    fechaRecepcion: "2026-06-01", fechaLimite: "2026-06-08",
    estado: "enviado_tribunal", prioridad: "alta",
    responsableId: "u4", responsableName: "Valentina Soto", responsableRol: "orientador",
    documentoOrigenNombre: "Complemento_Oficio_C5555-2026.pdf",
    comprobanteEnvioNombre: "Comprobante_Envio_Complemento_C5555.pdf", fechaEnvio: "2026-06-07",
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-06-01T09:00:00", updatedAt: "2026-06-07T14:00:00",
    semaforo: "verde", semaforoMotivo: "Informe complementario enviado el 07/06. Dentro del plazo.",
    observaciones: "Informe complementario sobre compromiso del apoderado enviado. Adjuntado comprobante de envío."
  },
  {
    id: "jr11", tenantId: "t1", studentId: "s1", studentName: "Benjamín Aravena Muñoz", caseId: "c1",
    tribunal: "Fiscalía Local de Santiago",
    rit: "RUC-2410344444-5", ruc: "2410344444-5", numeroCausa: "INV-2026-0789",
    tipoRequerimiento: "Solicitud de antecedentes escolares para investigación",
    fechaRecepcion: "2026-06-09", fechaLimite: "2026-06-23",
    estado: "recibido", prioridad: "critica",
    responsableId: null, responsableName: null, responsableRol: null,
    documentoOrigenNombre: "Solicitud_Fiscalia_Stgo_INV-2026-0789.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u5", createdByName: "Roberto Muñoz",
    createdAt: "2026-06-09T11:00:00", updatedAt: "2026-06-09T11:00:00",
    semaforo: "rojo", semaforoMotivo: "Requerimiento de Fiscalía. Sin responsable asignado. Alta criticidad.",
    observaciones: "Recibido de Fiscalía Local. Se requiere informe de antecedentes escolares generales del estudiante. Prioridad máxima por tratarse de investigación penal."
  },
  {
    id: "jr12", tenantId: "t1", studentId: "s7", studentName: "Cristóbal Ibáñez Vega", caseId: null,
    tribunal: "Tribunal de Familia de Santiago",
    rit: "C-1234-2025", ruc: "2410555666-7", numeroCausa: "C-1234-2025",
    tipoRequerimiento: "Informe de evolución del estudiante (segundo requerimiento)",
    fechaRecepcion: "2026-04-10", fechaLimite: "2026-05-15",
    estado: "cerrado", prioridad: "media",
    responsableId: "u4", responsableName: "Valentina Soto", responsableRol: "orientador",
    documentoOrigenNombre: "Oficio_Segundo_Requerimiento_C1234-2025.pdf",
    comprobanteEnvioNombre: "Comprobante_Envio_Segundo_Informe_C1234.pdf", fechaEnvio: "2026-05-12",
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-04-10T10:00:00", updatedAt: "2026-05-12T16:00:00",
    semaforo: "verde", semaforoMotivo: "Requerimiento cerrado. Informe enviado el 12/05/2026.",
    observaciones: "Segundo requerimiento del mismo tribunal para la misma causa. Informe de evolución enviado dentro del plazo."
  },
  {
    id: "jr13", tenantId: "t1", studentId: "s5", studentName: "Lucas Guzmán Soto", caseId: "c5",
    tribunal: "Tribunal de Familia de Puente Alto",
    rit: "C-8912-2026", ruc: "2410456789-0", numeroCausa: "C-8912-2026",
    tipoRequerimiento: "Recordatorio y ampliación de plazo — informe integral",
    fechaRecepcion: "2026-06-05", fechaLimite: "2026-06-18",
    estado: "en_revision", prioridad: "critica",
    responsableId: "u4", responsableName: "Valentina Soto", responsableRol: "orientador",
    documentoOrigenNombre: "Recordatorio_Ampliacion_Tribunal_PuenteAlto_C8912.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-06-05T14:00:00", updatedAt: "2026-06-09T10:00:00",
    semaforo: "amarillo", semaforoMotivo: "Borrador en revisión por orientadora. Plazo ampliado: 18/06.",
    observaciones: "El tribunal concedió ampliación de plazo tras solicitud del colegio (el requerimiento original JR4 estaba vencido). Nuevo plazo: 18/06. Prioridad máxima."
  },
  {
    id: "jr14", tenantId: "t1", studentId: "s2", studentName: "Martina Cáceres Rojas", caseId: null,
    tribunal: "Tribunal de Familia de San Bernardo",
    rit: "P-7890-2026", ruc: "2410666777-8", numeroCausa: "P-7890-2026",
    tipoRequerimiento: "Informe de intervenciones psicosociales realizadas",
    fechaRecepcion: "2026-06-07", fechaLimite: "2026-06-21",
    estado: "en_analisis_ia", prioridad: "alta",
    responsableId: null, responsableName: null, responsableRol: null,
    documentoOrigenNombre: "Oficio_Tribunal_SanBernardo_P7890.pdf",
    comprobanteEnvioNombre: null, fechaEnvio: null,
    createdBy: "u4", createdByName: "Valentina Soto",
    createdAt: "2026-06-07T13:00:00", updatedAt: "2026-06-07T13:00:00",
    semaforo: "amarillo", semaforoMotivo: "Documento en análisis por IA. Requiere extracción de datos.",
    observaciones: "Tribunal solicita informar intervenciones psicosociales realizadas con la estudiante y su familia. Relacionado con caso de acoso escolar."
  }
]);

// ── EXTRACTIONS ──
export const mockJudicialExtractions: JudicialExtraction[] = [
  {
    id: "je1", tenantId: "t1", judicialRequirementId: "jr1",
    extractedJson: {
      tribunal: "Tribunal de Familia de Santiago",
      fechaRecepcion: "2026-05-28",
      fechaLimite: "2026-06-15",
      rit: "C-2345-2026",
      ruc: "2410123456-7",
      numeroCausa: "C-2345-2026",
      estudiante: "Vicente Díaz Leiva",
      curso: "3° Medio C",
      tipoRequerimiento: "Informe integral del estudiante",
      informesSolicitados: ["rendimiento académico", "comportamiento en aula", "asistencia y puntualidad", "compromiso del apoderado", "intervenciones realizadas"],
      antecedentesRequeridos: ["notas parciales", "promedio general", "observaciones libro de clases", "% asistencia", "entrevistas con apoderado", "medidas de apoyo aplicadas"],
      responsablesSugeridos: ["Profesor Jefe", "Orientadora"],
      nivelUrgencia: "Alta - 15 días hábiles",
      accionesRecomendadas: ["Solicitar insumos a profesor jefe", "Recopilar antecedentes de inspectoría", "Generar informe con IA", "Validar por orientadora", "Enviar a tribunal"],
      advertencias: ["Plazo de 15 días hábiles desde notificación", "Se requiere firma del director", "Adjuntar todos los antecedentes solicitados"]
    },
    validatedBy: "u4", validatedByName: "Valentina Soto", validatedAt: "2026-05-28T14:30:00",
    createdAt: "2026-05-28T14:00:00"
  },
  {
    id: "je2", tenantId: "t1", judicialRequirementId: "jr5",
    extractedJson: {
      tribunal: "Tribunal de Familia de San Bernardo",
      fechaRecepcion: "2026-06-02",
      fechaLimite: "2026-06-25",
      rit: "P-3456-2026",
      ruc: "2410567890-1",
      numeroCausa: "P-3456-2026",
      estudiante: "Martina Cáceres Rojas",
      curso: "1° Medio B",
      tipoRequerimiento: "Informe de convivencia escolar y relación con pares",
      informesSolicitados: ["convivencia escolar", "relación con pares", "dinámica de curso"],
      antecedentesRequeridos: ["observaciones de aula", "registros de convivencia", "intervenciones realizadas", "medidas adoptadas"],
      responsablesSugeridos: ["Profesor Jefe", "Encargado de Convivencia"],
      nivelUrgencia: "Alta - 23 días corridos",
      accionesRecomendadas: ["Solicitar informe a profesor jefe Andrea Vásquez", "Recopilar registros de convivencia", "Entrevistar a orientadora sobre intervenciones previas"],
      advertencias: ["Caso sensible: posible acoso escolar", "Proteger identidad de la estudiante en el informe"]
    },
    validatedBy: "u4", validatedByName: "Valentina Soto", validatedAt: "2026-06-02T16:30:00",
    createdAt: "2026-06-02T16:15:00"
  },
  {
    id: "je3", tenantId: "t1", judicialRequirementId: "jr7",
    extractedJson: {
      tribunal: "Tribunal de Familia de Santiago",
      fechaRecepcion: "2026-05-10",
      fechaLimite: "2026-06-10",
      rit: "P-4321-2026",
      ruc: "2410789012-3",
      numeroCausa: "P-4321-2026",
      estudiante: "Isidora Flores Paredes",
      curso: "2° Medio A",
      tipoRequerimiento: "Informe de intervenciones realizadas y seguimiento",
      informesSolicitados: ["intervenciones realizadas", "seguimiento escolar", "evolución del estudiante"],
      antecedentesRequeridos: ["sesiones de orientación", "entrevistas con la estudiante", "comunicación con apoderada", "plan de acompañamiento"],
      responsablesSugeridos: ["Orientadora", "Profesor Jefe"],
      nivelUrgencia: "Alta - vence 10/06",
      accionesRecomendadas: ["Recopilar registros de sesiones de orientación", "Solicitar observaciones a profesor jefe", "Generar informe con IA"],
      advertencias: ["Información confidencial - tema de salud mental", "No incluir diagnósticos no respaldados"]
    },
    validatedBy: "u4", validatedByName: "Valentina Soto", validatedAt: "2026-05-10T16:00:00",
    createdAt: "2026-05-10T15:30:00"
  },
];

// ── TASKS ──
export const mockJudicialTasks: JudicialTask[] = [
  { id: "jt1", tenantId: "t1", judicialRequirementId: "jr1", responsableId: "u8", responsableName: "Felipe Contreras", titulo: "Entregar insumos académicos de Vicente Díaz", descripcion: "Completar formulario de antecedentes: rendimiento, comportamiento, asistencia y compromiso del apoderado para causa C-2345-2026.", estado: "vencida", fechaLimite: "2026-06-05", createdAt: "2026-05-30T11:00:00" },
  { id: "jt2", tenantId: "t1", judicialRequirementId: "jr1", responsableId: "u4", responsableName: "Valentina Soto", titulo: "Generar informe integral con IA", descripcion: "Una vez recibidos los insumos, generar borrador de informe integral con IA para el Tribunal de Familia de Santiago.", estado: "pendiente", fechaLimite: "2026-06-12", createdAt: "2026-05-30T11:00:00" },
  { id: "jt3", tenantId: "t1", judicialRequirementId: "jr3", responsableId: "u5", responsableName: "Roberto Muñoz", titulo: "Asignar responsable al requerimiento", descripcion: "Designar orientadora o encargado responsable de responder el requerimiento del Tribunal de Garantía.", estado: "pendiente", fechaLimite: "2026-06-08", createdAt: "2026-06-05T09:00:00" },
  { id: "jt4", tenantId: "t1", judicialRequirementId: "jr7", responsableId: "u4", responsableName: "Valentina Soto", titulo: "Revisar y validar borrador de informe", descripcion: "Revisar el borrador generado por IA para Isidora Flores. Validar contenido, tono y suficiencia antes de enviar.", estado: "pendiente", fechaLimite: "2026-06-10", createdAt: "2026-06-08T17:00:00" },
  { id: "jt5", tenantId: "t1", judicialRequirementId: "jr4", responsableId: "u5", responsableName: "Roberto Muñoz", titulo: "Responder requerimiento vencido con urgencia", descripcion: "⚠️ El requerimiento C-8912-2026 está vencido desde el 01/06. Se debe priorizar la elaboración del informe y contactar al tribunal.", estado: "vencida", fechaLimite: "2026-06-01", createdAt: "2026-05-15T11:00:00" },
  { id: "jt6", tenantId: "t1", judicialRequirementId: "jr9", responsableId: "u4", responsableName: "Valentina Soto", titulo: "Generar informe institucional para Corte de Apelaciones", descripcion: "Redactar informe sobre protocolos de convivencia aplicados. Utilizar IA para generar borrador inicial.", estado: "pendiente", fechaLimite: "2026-06-10", createdAt: "2026-06-07T12:00:00" },
  { id: "jt7", tenantId: "t1", judicialRequirementId: "jr11", responsableId: "u5", responsableName: "Roberto Muñoz", titulo: "Designar responsable para requerimiento de Fiscalía", descripcion: "Requerimiento urgente de Fiscalía Local. Designar orientadora a cargo y coordinar respuesta.", estado: "pendiente", fechaLimite: "2026-06-10", createdAt: "2026-06-09T11:00:00" },
  { id: "jt8", tenantId: "t1", judicialRequirementId: "jr13", responsableId: "u4", responsableName: "Valentina Soto", titulo: "Finalizar revisión y enviar informe", descripcion: "Completar revisión del borrador y enviar informe integral al Tribunal de Familia de Puente Alto. Nuevo plazo: 18/06.", estado: "pendiente", fechaLimite: "2026-06-16", createdAt: "2026-06-09T10:00:00" },
  { id: "jt9", tenantId: "t1", judicialRequirementId: "jr10", responsableId: "u4", responsableName: "Valentina Soto", titulo: "Archivar requerimiento completado", descripcion: "Cerrar requerimiento JR10. Archivar comprobante de envío y documentación asociada.", estado: "completada", fechaLimite: "2026-06-08", createdAt: "2026-06-07T14:00:00" },
];

// ── LOGS ──
export const mockJudicialLogs: JudicialLog[] = [
  { id: "jl1", tenantId: "t1", judicialRequirementId: "jr1", userId: "u4", userName: "Valentina Soto", accion: "Creación del requerimiento", detalle: "Se creó el requerimiento judicial a partir del oficio del Tribunal de Familia de Santiago, causa C-2345-2026.", createdAt: "2026-05-28T10:00:00" },
  { id: "jl2", tenantId: "t1", judicialRequirementId: "jr1", userId: "u4", userName: "Valentina Soto", accion: "Validación de extracción IA", detalle: "Validó los datos extraídos automáticamente por IA del oficio judicial.", createdAt: "2026-05-28T14:30:00" },
  { id: "jl3", tenantId: "t1", judicialRequirementId: "jr1", userId: "u4", userName: "Valentina Soto", accion: "Solicitud de insumos", detalle: "Solicitó insumos a Felipe Contreras (profesor jefe) con plazo 05/06/2026.", createdAt: "2026-05-30T11:00:00" },
  { id: "jl4", tenantId: "t1", judicialRequirementId: "jr1", userId: "u4", userName: "Valentina Soto", accion: "Alerta de vencimiento", detalle: "Insumo docente de Felipe Contreras venció sin ser entregado. El sistema marcó la tarea como vencida.", createdAt: "2026-06-06T08:00:00" },
  { id: "jl5", tenantId: "t1", judicialRequirementId: "jr2", userId: "u4", userName: "Valentina Soto", accion: "Generación de informe con IA", detalle: "Se generó borrador de informe de comportamiento y convivencia escolar con IA.", createdAt: "2026-06-05T10:00:00" },
  { id: "jl6", tenantId: "t1", judicialRequirementId: "jr2", userId: "u5", userName: "Roberto Muñoz", accion: "Aprobación de informe", detalle: "Director aprobó el informe de comportamiento y convivencia escolar para el Tribunal de Familia de San Miguel.", createdAt: "2026-06-07T11:00:00" },
  { id: "jl7", tenantId: "t1", judicialRequirementId: "jr2", userId: "u4", userName: "Valentina Soto", accion: "Envío al tribunal", detalle: "Informe enviado al Tribunal de Familia de San Miguel vía correo electrónico institucional. Se adjuntó comprobante.", createdAt: "2026-06-09T15:30:00" },
  { id: "jl8", tenantId: "t1", judicialRequirementId: "jr7", userId: "u4", userName: "Valentina Soto", accion: "Generación de borrador con IA", detalle: "Se generó borrador de informe de intervenciones y seguimiento para Isidora Flores.", createdAt: "2026-06-08T17:00:00" },
  { id: "jl9", tenantId: "t1", judicialRequirementId: "jr13", userId: "u4", userName: "Valentina Soto", accion: "Solicitud de ampliación de plazo", detalle: "Se solicitó al tribunal ampliación de plazo para el requerimiento original JR4 (vencido). El tribunal concedió nuevo plazo hasta 18/06.", createdAt: "2026-06-05T14:00:00" },
  { id: "jl10", tenantId: "t1", judicialRequirementId: "jr13", userId: "u4", userName: "Valentina Soto", accion: "Borrador en revisión", detalle: "El borrador del informe integral fue revisado por orientadora. Se realizaron ajustes menores.", createdAt: "2026-06-09T10:00:00" },
];

// ── REQUIREMENT INPUTS (insumos solicitados para requerimientos judiciales) ──
export const mockJudicialRequirementInputs: JudicialRequirementInput[] = [
  { id: "jri1", tenantId: "t1", judicialRequirementId: "jr1", tipoInsumo: "Rendimiento académico y comportamiento", descripcion: "Se solicita informe de rendimiento (notas parciales y promedio), comportamiento en aula y observaciones del libro de clases del estudiante Vicente Díaz.", responsableId: "u8", responsableName: "Felipe Contreras", responsableRol: "profesor_jefe", fechaLimite: "2026-06-05", estado: "vencido", respuesta: null, createdAt: "2026-05-30T11:00:00" },
  { id: "jri2", tenantId: "t1", judicialRequirementId: "jr1", tipoInsumo: "Asistencia y puntualidad", descripcion: "Se solicita registro de asistencia, inasistencias justificadas e injustificadas y atrasos del estudiante Vicente Díaz.", responsableId: "u2", responsableName: "Marcela Rivas", responsableRol: "inspector", fechaLimite: "2026-06-05", estado: "entregado", respuesta: "Durante el semestre, Vicente Díaz registra 85% de asistencia, con 12 inasistencias (3 justificadas, 9 injustificadas). Presenta 6 atrasos en el periodo.", createdAt: "2026-05-30T11:30:00" },
  { id: "jri3", tenantId: "t1", judicialRequirementId: "jr7", tipoInsumo: "Registro de sesiones de orientación", descripcion: "Se solicita detalle de las sesiones de orientación realizadas con Isidora Flores: fechas, temas tratados, acuerdos y avances observados.", responsableId: "u4", responsableName: "Valentina Soto", responsableRol: "orientador", fechaLimite: "2026-06-03", estado: "entregado", respuesta: "Se realizaron 4 sesiones de orientación con la estudiante entre el 05/05 y el 02/06. Temas: regulación emocional, presión académica, comunicación familiar. Se observa leve mejora en la expresión emocional.", createdAt: "2026-05-12T10:00:00" },
  { id: "jri4", tenantId: "t1", judicialRequirementId: "jr7", tipoInsumo: "Observaciones de profesor jefe", descripcion: "Se solicita al profesor jefe observaciones sobre participación en clases, relación con pares y disposición al aprendizaje de Isidora Flores.", responsableId: "u3", responsableName: "Carlos Herrera", responsableRol: "profesor_jefe", fechaLimite: "2026-06-05", estado: "aprobado", respuesta: "La estudiante mantiene buena disposición al aprendizaje. Participa en clases de forma regular. En las últimas semanas se ha observado mayor retraimiento en trabajos grupales, lo cual fue informado a orientación.", createdAt: "2026-05-14T09:00:00" },
  { id: "jri5", tenantId: "t1", judicialRequirementId: "jr9", tipoInsumo: "Protocolos de convivencia aplicados", descripcion: "Se solicita listado de protocolos de convivencia activados en el establecimiento durante el año 2026, con detalle de casos y resoluciones.", responsableId: "u11", responsableName: "Carolina Paredes", responsableRol: "convivencia", fechaLimite: "2026-06-05", estado: "entregado", respuesta: "Protocolos aplicados en 2026: Acoso Escolar (2 casos), Agresión Física (3 casos), Consumo de Sustancias (1 caso), Desregulación Emocional (2 casos). Se adjunta detalle de cada caso.", createdAt: "2026-05-28T08:00:00" },
  { id: "jri6", tenantId: "t1", judicialRequirementId: "jr13", tipoInsumo: "Informe integral del estudiante", descripcion: "Se solicita al profesor jefe informe completo de Lucas Guzmán: rendimiento, comportamiento, asistencia, compromiso del apoderado, y medidas de apoyo aplicadas.", responsableId: "u9", responsableName: "Romina Alarcón", responsableRol: "profesor_jefe", fechaLimite: "2026-06-12", estado: "en_desarrollo", respuesta: null, createdAt: "2026-06-05T14:30:00" },
  { id: "jri7", tenantId: "t1", judicialRequirementId: "jr5", tipoInsumo: "Informe de convivencia y relación con pares", descripcion: "Se solicita informe sobre dinámica de curso, relación de Martina Cáceres con sus compañeras y cualquier antecedente de convivencia relevante.", responsableId: "u7", responsableName: "Andrea Vásquez", responsableRol: "profesor_jefe", fechaLimite: "2026-06-16", estado: "pendiente", respuesta: null, createdAt: "2026-06-03T09:00:00" },
];

// ── DASHBOARD DATA ──
export const mockJudicialDashboard = {
  totalActivos: 10,
  proximosVencer: 3,
  vencidos: 1,
  informesPendientes: 4,
  informesEnviados: 2,
  docentesConInsumosPendientes: 3,
  casosJudicializadosPorCurso: [
    { curso: "3° Medio C", cantidad: 2 },
    { curso: "2° Medio A", cantidad: 2 },
    { curso: "4° Medio B", cantidad: 2 },
    { curso: "1° Medio B", cantidad: 2 },
    { curso: "1° Medio A", cantidad: 1 },
    { curso: "2° Medio C", cantidad: 1 },
    { curso: "3° Medio B", cantidad: 1 },
    { curso: "Institucional", cantidad: 1 },
  ],
  requerimientosPorTribunal: [
    { tribunal: "Tribunal de Familia de Santiago", cantidad: 4 },
    { tribunal: "Tribunal de Familia de San Miguel", cantidad: 2 },
    { tribunal: "Tribunal de Familia de Puente Alto", cantidad: 2 },
    { tribunal: "Tribunal de Familia de San Bernardo", cantidad: 2 },
    { tribunal: "Tribunal de Garantía de Santiago", cantidad: 1 },
    { tribunal: "Fiscalía Local de Santiago", cantidad: 1 },
    { tribunal: "Corte de Apelaciones de San Miguel", cantidad: 1 },
    { tribunal: "Tribunal de Familia de La Florida", cantidad: 1 },
  ],
  tiempoPromedioRespuesta: "12 días",
  cumplimientoMensual: [
    { mes: "Enero", recibidos: 1, respondidos: 1 },
    { mes: "Febrero", recibidos: 0, respondidos: 0 },
    { mes: "Marzo", recibidos: 2, respondidos: 2 },
    { mes: "Abril", recibidos: 3, respondidos: 2 },
    { mes: "Mayo", recibidos: 5, respondidos: 3 },
    { mes: "Junio", recibidos: 6, respondidos: 2 },
  ],
  alertasCriticas: [
    { tipo: "Requerimiento vencido", descripcion: "JR4: Tribunal de Familia de Puente Alto - Lucas Guzmán (01/06)", nivel: "rojo" },
    { tipo: "Insumo docente vencido", descripcion: "JR1: Felipe Contreras - Vicente Díaz (05/06)", nivel: "rojo" },
    { tipo: "Sin responsable asignado", descripcion: "JR3: Tribunal de Garantía - Benjamín Aravena", nivel: "rojo" },
    { tipo: "Sin responsable asignado", descripcion: "JR11: Fiscalía Local - Benjamín Aravena", nivel: "rojo" },
    { tipo: "Plazo vence HOY", descripcion: "JR7: Tribunal de Familia de Santiago - Isidora Flores (10/06)", nivel: "rojo" },
    { tipo: "Próximo a vencer", descripcion: "JR9: Corte de Apelaciones - Informe institucional (12/06)", nivel: "amarillo" },
    { tipo: "Próximo a vencer", descripcion: "JR1: Tribunal de Familia de Santiago - Vicente Díaz (15/06)", nivel: "amarillo" },
  ],
};

// ── STATE LABELS ──
export function getJudicialStateLabel(estado: JudicialRequirementState): string {
  const labels: Record<JudicialRequirementState, string> = {
    recibido: "Recibido",
    en_analisis_ia: "En análisis IA",
    datos_extraidos: "Datos extraídos",
    pendiente_asignacion: "Pendiente de asignación",
    solicitando_insumos: "Solicitando insumos",
    insumos_incompletos: "Insumos incompletos",
    insumos_completos: "Insumos completos",
    informe_en_elaboracion: "Informe en elaboración",
    borrador_generado: "Borrador generado",
    en_revision: "En revisión",
    aprobado: "Aprobado",
    enviado_tribunal: "Enviado a tribunal",
    vencido: "Vencido",
    cerrado: "Cerrado",
  };
  return labels[estado] || estado;
}

export function getJudicialStateColor(estado: JudicialRequirementState): string {
  switch (estado) {
    case "recibido": return "bg-slate-100 text-slate-700 border-slate-200";
    case "en_analisis_ia": return "bg-purple-100 text-purple-700 border-purple-200";
    case "datos_extraidos": return "bg-indigo-100 text-indigo-700 border-indigo-200";
    case "pendiente_asignacion": return "bg-red-100 text-red-700 border-red-200";
    case "solicitando_insumos": return "bg-amber-100 text-amber-700 border-amber-200";
    case "insumos_incompletos": return "bg-amber-100 text-amber-700 border-amber-200";
    case "insumos_completos": return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "informe_en_elaboracion": return "bg-sky-100 text-sky-700 border-sky-200";
    case "borrador_generado": return "bg-cyan-100 text-cyan-700 border-cyan-200";
    case "en_revision": return "bg-amber-100 text-amber-700 border-amber-200";
    case "aprobado": return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "enviado_tribunal": return "bg-emerald-100 text-emerald-700 border-emerald-200";
    case "vencido": return "bg-red-100 text-red-700 border-red-200";
    case "cerrado": return "bg-foreground-100 text-foreground-700 border-foreground-200";
    default: return "bg-foreground-100 text-foreground-700 border-foreground-200";
  }
}

export function getSemaforoColor(semaforo: string): string {
  switch (semaforo) {
    case "verde": return "bg-emerald-500";
    case "amarillo": return "bg-amber-500";
    case "rojo": return "bg-red-500";
    default: return "bg-foreground-400";
  }
}

export function getSemaforoBgColor(semaforo: string): string {
  switch (semaforo) {
    case "verde": return "bg-emerald-50 border-emerald-200 text-emerald-800";
    case "amarillo": return "bg-amber-50 border-amber-200 text-amber-800";
    case "rojo": return "bg-red-50 border-red-200 text-red-800";
    default: return "bg-foreground-50 border-foreground-200 text-foreground-800";
  }
}

export function getPrioridadColor(prioridad: string): string {
  switch (prioridad) {
    case "critica": return "bg-red-100 text-red-700 border-red-200";
    case "alta": return "bg-amber-100 text-amber-700 border-amber-200";
    case "media": return "bg-sky-100 text-sky-700 border-sky-200";
    case "baja": return "bg-foreground-100 text-foreground-700 border-foreground-200";
    default: return "bg-foreground-100 text-foreground-700 border-foreground-200";
  }
}